import type { ImportRunResponse, RunRecordResponse } from '@flixflow/shared';
import { apiFetch } from './client.js';

export const importRunsApi = {
  listForProfile: (profileId: string, limit = 20) =>
    apiFetch<ImportRunResponse[]>(`/api/import-profiles/${profileId}/runs?limit=${limit}`),
  get: (runId: string) => apiFetch<ImportRunResponse>(`/api/import-runs/${runId}`),
  getRecords: (runId: string, limit = 100, offset = 0) =>
    apiFetch<RunRecordResponse[]>(
      `/api/import-runs/${runId}/records?limit=${limit}&offset=${offset}`,
    ),
  cancel: (runId: string) =>
    apiFetch<{ cancelled: boolean }>(`/api/import-runs/${runId}/cancel`, { method: 'POST' }),

  /** Upload a file and trigger an import run. Returns the created run. */
  trigger: async (profileId: string, file: File, csrfToken: string): Promise<ImportRunResponse> => {
    const form = new FormData();
    form.append('file', file);
    const resp = await fetch(`/api/import-profiles/${profileId}/runs`, {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrfToken },
      credentials: 'include',
      body: form,
    });
    if (!resp.ok) {
      const err = (await resp.json().catch(() => ({}))) as { error?: string };
      throw new Error(err.error ?? `HTTP ${resp.status}`);
    }
    return resp.json() as Promise<ImportRunResponse>;
  },
};
